/** Strings owned by `src/features/users/` — WP-12's Users section (scoped
 * to the active company), `UserDetailPage`, `UserEditPage`, `AddPersonPage`
 * en `memberActions.tsx` (§ Bedrijfscontext, § Zichtbaarheid). */
export const users = {
  page: {
    title: 'Gebruikers',
    noScope: 'Je hebt geen beheerbevoegdheid, dus er is geen ledenlijst om te tonen.',
    departmentListsTitle: 'Ledenlijsten per afdeling',
    leadCompany: 'Leden van {{company}}.',
    membersOf: 'Leden van {{company}}',
    companyMembersCardTitle: 'Leden',
    addPerson: 'Persoon toevoegen',
    empty: 'Geen leden.',
    name: 'Naam',
    email: 'E-mail',
    login: 'Login',
    source: 'Bron',
    yes: 'ja',
    no: 'nee',
    invitePerson: 'Uitnodigen',
    importCsv: 'CSV importeren',
    searchPlaceholder: 'Zoek op naam of e-mail…',
    filterDepartment: 'Afdeling',
    allDepartments: 'Alle afdelingen',
    filterLocation: 'Locatie',
    allLocations: 'Alle locaties',
    filterStatus: 'Status',
    allStatuses: 'Alle statussen',
    employee: 'Medewerker',
    department: 'Afdeling',
    location: 'Locatie',
    lastSync: 'Laatste sync',
    consent: 'Consent',
    wearable: 'Wearable',
    pilot: 'Pilot',
    account: 'Account',
    actions: 'Acties',
    accountActive: 'Actief',
    accountDeactivated: 'Gedeactiveerd',
    noLocation: 'Geen locatie',
    noDepartment: 'Geen afdeling',
    activation: {
      label: 'Activatie',
      invited: 'Uitgenodigd',
      activated: 'Geactiveerd',
      active: 'Actief',
      inactive: 'Inactief',
      deactivated: 'Gedeactiveerd',
    },
    consentStatus: {
      pending: 'In afwachting',
      confirmed: 'Toestemming',
      declined: 'Ingetrokken',
      none: 'Geen',
    },
  },
  detail: {
    thisPerson: 'deze persoon',
    edit: 'Bewerken',
    name: 'Naam',
    email: 'E-mail',
    nickname: 'Bijnaam',
    preferredLanguage: 'Voorkeurstaal',
    region: 'Regio',
    login: 'Login',
    yes: 'ja',
    no: 'nee',
    gender: 'Geslacht',
    birthdate: 'Geboortedatum',
    height: 'Lengte',
    weight: 'Gewicht',
    privateNote:
      'Geslacht, geboortedatum, lengte en gewicht zijn privé voor deze persoon en maken geen deel uit van hoe anderen hem of haar zien.',
    actionsCardTitle: 'Acties',
    statsCardTitle: 'Statistieken',
  },
  edit: {
    title: 'Persoonlijke gegevens bewerken',
    lead: 'Naam en e-mail komen van het inlogaccount en kunnen hier niet worden gewijzigd.',
    cancel: 'Annuleren',
    save: 'Opslaan',
  },
  addPerson: {
    created: 'Persoon aangemaakt.',
    inviteSent: 'Er is een uitnodigingsmail onderweg.',
    alreadyHasLogin: 'Deze persoon heeft al een login.',
    noLoginYet: 'Nog geen login — je kunt die later uitnodigen vanuit de ledenlijst.',
    done: 'Klaar',
    name: 'Naam',
    email: 'E-mail',
    emailHint: 'Optioneel — met een adres wordt de persoon uitgenodigd om in te loggen.',
    nickname: 'Bijnaam',
    region: 'Regio',
    conflict:
      'Er bestaat al een persoon met dit e-mailadres{{reason}}. Voeg die bestaande persoon toe aan de scope in plaats van een dubbele aan te maken.',
    cancel: 'Annuleren',
    create: 'Persoon aanmaken',
    companyTitle: 'Persoon toevoegen aan het bedrijf',
    departmentTitle: 'Persoon toevoegen aan de afdeling',
    newPersonCardTitle: 'Nieuwe persoon',
    existingCardTitle: 'Bestaand bedrijfslid',
    existingPersonCardTitle: 'Bestaande persoon',
    member: 'Lid',
    person: 'Persoon',
    choose: 'Kies…',
    addToDepartment: 'Toevoegen aan afdeling',
    addToCompany: 'Toevoegen aan bedrijf',
    searchPeople: 'Personen zoeken',
    searchPlaceholder: 'Naam of e-mail',
    noEligible: 'Geen passende persoon gevonden.',
    editionMismatch:
      'Deze persoon heeft een andere editie dan het bedrijf. Pas eerst de editie van de persoon of het bedrijf aan en probeer het opnieuw.',
  },
  actions: {
    invite: 'Uitnodigen',
    inviteAgain: 'Opnieuw uitnodigen',
    changeEmail: 'E-mail wijzigen',
    newEmail: 'Nieuw e-mailadres',
    save: 'Opslaan',
    cancel: 'Annuleren',
    remove: 'Verwijderen',
    unlink: 'Ontkoppelen',
    unlinkFromPilot: 'Ontkoppelen van pilot',
    erase: 'Wissen',
    changeLocation: 'Locatie wijzigen',
    changeDepartment: 'Afdeling wijzigen',
    deactivate: 'Deactiveren',
    activate: 'Activeren',
  },
  invite: {
    title: 'Persoon uitnodigen',
    name: 'Naam',
    email: 'E-mailadres',
    role: 'Rol',
    roleMember: 'Medewerker',
    roleAdmin: 'Bedrijfsbeheerder',
    submit: 'Uitnodigen',
    cancel: 'Annuleren',
  },
  import: {
    title: 'CSV importeren',
    instructions: 'Plak of upload een CSV met kolommen: naam, email, afdeling, locatie.',
    csvLabel: 'CSV',
    placeholder: 'Jane Doe,jane@example.com,Sales,DC Rotterdam',
    uploadLabel: 'Of upload een bestand',
    submit: 'Importeren',
    cancel: 'Annuleren',
    done: 'Klaar',
    summary: '{{imported}} geïmporteerd, {{failed}} mislukt.',
    rowLabel: 'Rij {{row}}',
    rowSuccess: 'Geïmporteerd',
    rowFailed: 'Mislukt',
  },
} as const;
